<template>
  <div class="wrap1" v-loading.fullscreen.lock="loading">
    <h2 class="common-title">
      <i class="el-icon-arrow-left icon" @click="handlerBack"></i>
      <span>{{ activeData.info.sub_project_name }}</span>
    </h2>
    <div class="wrap1-box wrap1-btn">
      <el-steps class="steps" :active="activeStep" align-center finish-status="success">
        <el-step v-for="item in tabPaneArr" :key="item.id" :title="$t(item.name)"></el-step>
      </el-steps>
      <component
        class="ruleForm"
        v-if="activeObj.comp"
        :is="activeObj.comp"
        :ref="activeObj.title"
        :activeData="activeData"
        @changeList="changeList"
        @next="next"
        @disabled="handleDisabled"
      ></component>
    </div>
    <el-row class="flex-btn">
      <!-- 上一步 -->
      <el-button
        v-if="activeStep > 0 && activeData.info.sub_project_status !== '3'"
        :disabled="[2].includes(activeData.state) || nextDisabled"
        size="small"
        @click="prev"
        >{{ $t('422') }}</el-button
      >
      <!-- 下一步 计算 -->
      <el-button
        v-if="activeStep !== tabPaneArr.length - 1 && activeData.info.sub_project_status !== '3'"
        :disabled="!subStaffList.length || nextDisabled"
        size="small"
        type="primary"
        @click="next"
        >{{ activeStep === 1 ? $t('payroll_wage_29') : $t('331') }}</el-button
      >
      <!-- 发放工资条 -->
      <el-button
        v-if="activeData.info.sub_project_status === '3' && $p('menu.payroll.scheme.edit')"
        size="small"
        @click="goToDetail(3)"
        >{{ $t('payroll_wage_13') }}</el-button
      >
      <!-- 生成工资表 -->
      <el-button
        v-if="
          activeStep === tabPaneArr.length - 1 &&
          activeData.info.sub_project_status !== '3' &&
          $p('menu.payroll.wage.edit')
        "
        :disabled="activeData.state !== 3 && activeData.info.sub_project_status !== '3'"
        size="small"
        type="primary"
        @click="handleArchive"
        >{{ $t('393') }}</el-button
      >
    </el-row>
    <ExportExcelDialog ref="ExportExcelDialog" />
  </div>
</template>

<script>
import { tabPaneArr, tabData } from './conf'
import {
  payrollSubProjectInfo,
  calculate,
  getSubProjectCalculateState,
  getOnFileNotice,
  payrollSubProjectOnFile
} from '@/api/payroll'
import ExportExcelDialog from '@/components/ExportExcelDialog'

export default {
  components: {
    [ExportExcelDialog.name]: ExportExcelDialog
  },
  data() {
    return {
      loading: false,
      activeStep: 0,
      activeObj: {},
      tabPaneArr,
      activeData: tabData,
      isDisable: true,
      projectId: this.$route.params.id,
      clearTime: null,
      subStaffList: [],
      // 控制步骤按钮
      nextDisabled: false
    }
  },
  created() {
    this.inif()
  },
  beforeRouteLeave(to, from, next) {
    if (this.activeData.state === 2) {
      this.$message({
        message: this.$t('payroll_salary_30'),
        type: 'warning'
      })
    }
    next()
  },
  methods: {
    inif() {
      this.activeObj = this.tabPaneArr[this.activeStep]
      this.loadSubProjectInfo() // 获取子项目信息
      this.startTraining(true) // 当前数据状态
    },
    // 步骤条禁用
    handleDisabled(bool) {
      this.nextDisabled = bool
    },
    async loadSubProjectInfo() {
      // 获取子项目信息
      const res = await payrollSubProjectInfo({
        sub_project_id: this.projectId
      })
      if (res && res.code === 1) {
        const subProjectInfo = res.data
        this.$set(subProjectInfo, 'date', [res.data.start_date, res.data.end_date])
        this.$set(subProjectInfo, 'att_date', [res.data.att_start_date, res.data.att_end_date])
        this.activeData.info = subProjectInfo
        if (subProjectInfo.sub_project_status === '3') {
          this.activeStep = 2
          this.activeObj = this.tabPaneArr[this.activeStep]
        }
      }
    },
    handlerBack() {
      // 返回上一层
      this.$router.push({
        path: '/payroll/wage',
        query: {
          name: this.$route.query.name
        }
      })
    },
    changeList(val) {
      if (val && val.length) this.subStaffList = val
    },
    prev() {
      // 上一步
      this.activeStep--
      this.activeObj = this.tabPaneArr[this.activeStep]
    },
    async next() {
      // 下一步
      try {
        if (this.activeStep === 1) {
          // 去算薪
          await calculate({ sub_project_id: this.projectId })
          // 当前子项目状态
          const calculateState = await getSubProjectCalculateState({ sub_id: this.projectId })
          if (calculateState && calculateState.code === 1) {
            // state 4(计算失败) state 为3(计算完成) 或 state为2且is_self_task为1 跳转step3
            const state = Number(calculateState.data.state)
            const is_self_task = Number(calculateState.data.is_self_task)
            this.activeData.is_self_task = is_self_task
            this.activeData.state = state
            if ([3, 4].includes(state) || (state === 2 && is_self_task === 1)) {
              // 为2 一直循环状态接口
              if (state === 2) {
                // 点击计算如果有page 需清空，否则会跳转道核对算薪人员
                if (this.$route.query.page) this.$router.push({ query: { ...this.$route.query, page: '' } })
                this.startTraining(true)
              }
              this.activeStep++
              this.activeObj = this.tabPaneArr[this.activeStep]
            } else {
              // 不是本人操作返回列表页
              this.$router.push({
                path: '/payroll/wage',
                query: {
                  name: this.$route.query.name
                }
              })
            }
          }
        } else {
          this.activeStep++
          this.activeObj = this.tabPaneArr[this.activeStep]
        }
      } catch {}
    },
    handleArchive() {
      let str = '<div>'
      getOnFileNotice({ sub_project_id: this.projectId }).then(res => {
        if (res.data.is_show_notice) {
          str += `
      <p>${this.$t('payroll_wage_50')}</p>
      `
        } else {
          str += `<p>${this.$t('payroll_wage_49')}</p>`
        }
        str += '</div>'
        // 进行中 归档
        this.$confirm(str, this.$t('229'), {
          confirmButtonText: this.$t('1031'),
          cancelButtonText: this.$t('66'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          payrollSubProjectOnFile({ sub_project_id: this.projectId }).then(res => {
            this.$router.push(`/payroll/wage?name=${this.$route.query.name}&pid=${this.projectId}`)
          })
        })
      })
    },
    computedPayroll() {
      const params = { relation_type: 3, relation_id: this.projectId }
      const data = { sub_project_id: this.projectId }
      this.$refs.ExportExcelDialog.init(params, data)
      // 下载工资条
      // this.downloading = true
      // downloadPaySheet({ sub_project_id: this.projectId })
      //   .then(res => {
      //     if (res && res.code === 1) {
      //       this.$message({
      //         message: this.$t('payroll_salary_30'),
      //         type: 'success'
      //       })
      //     }
      //   })
      //   .finally(() => (this.downloading = false))
    },
    goToDetail(state) {
      // 发放工资条
      this.$router.push({
        path: '/payroll/paywages-pay-slip/' + this.activeData.info.sub_project_id,
        query: {
          state,
          type: this.activeData.info.settlement_type,
          tax_deduction_status: this.activeData.info.tax_deduction_status
        }
      })
    },
    startTraining(type) {
      // 开始轮训
      if (!type) {
        // 为false 关闭定时器
        clearTimeout(this.clearTime)
        return
      }
      const this_ = this
      async function timerFn() {
        // 获取子项目状态
        const res = await getSubProjectCalculateState({ sub_id: this_.projectId })
        if (res && res.code === 1) {
          this_.activeData.state = Number(res.data.state)
          this_.activeData.is_self_task = Number(res.data.is_self_task)
        }
        // state: 3子项目为计算完成
        if ([3, 4].includes(this_.activeData.state)) {
          this_.loadSubProjectInfo()
          // 有page需跳转对应页面，没有则跳转第二个页面
          this_.activeStep = this_.$route.query.page ? Number(this_.$route.query.page) : 2
          this_.activeObj = this_.tabPaneArr[this_.activeStep]
        }
        // state: 2子项目为计算中状态
        if (this_.activeData.state === 2) {
          // is_self_task: 1是本人操作、停留在该页面接口一直请求 直到状态改为3，计算成功
          if (this_.activeData.is_self_task === 1) {
            this_.activeStep = 2
            this_.activeObj = this_.tabPaneArr[this_.activeStep]
            this_.clearTime = setTimeout(timerFn, 5000)
          } else {
            // 不是本人操作返回列表页
            this_.$router.push('/payroll/wage')
          }
        }
      }
      timerFn()
    }
  },
  beforeDestroy() {
    // 停止轮训
    this.startTraining(false)
  }
}
</script>

<style lang="scss" scoped>
.wrap1-box {
  /deep/ .steps {
    padding: 24px 0;
    border-bottom: 1px solid #f0f0f0;
    .el-step__head {
      &.is-success {
        color: #f0f0f0;
        border-color: #f0f0f0;
        border-width: 1px;
        .el-step__line {
          height: 1px;
          background: #f0f0f0;
        }
        .is-text {
          background: #fff;
          border-color: #5D51DA;
          .el-step__icon-inner {
            color: #5D51DA;
          }
        }
      }
      &.is-process,
      &.is-finish {
        .is-text {
          background: #5D51DA;
          border-color: #5D51DA;
        }
        .el-step__icon-inner {
          color: #fff;
        }
      }
    }
    .el-step__line {
      height: 1px;
      background: #f0f0f0;
    }
    .el-step__icon {
      width: 32px;
      height: 32px;
      border: 1px solid;
    }
    .el-step__main {
      .is-wait {
        font-size: 16px;
        color: #8c8c8c;
      }
      .is-finish {
        font-size: 16px;
        color: #262626;
      }
      .is-success {
        font-size: 16px;
        color: #595959;
      }
    }
  }
  .ruleForm {
    padding-top: 24px;
  }
}
</style>
